/**
 * Created by qlong on 9/12/2016.
 */

export function resetFilterGrid(){
    return {
        type: "RESET_FILTER_GRID",
        payload: null,
    }
}

export function addFilterGridData(filterGridData){
    return {
        type: "ADD_FILTER_GRID_DATA",
        payload: filterGridData,
    }
}
export function deleteColor(index){
    return {
        type: "DELETE_COLOR",
        payload: index,
    }
}

export function setColor(index, color){
    return {
        type: "SET_COLOR",
        payload: {color: color, index: index}
    }
}

export function addColorSet(color){
    return {
        type: "ADD_COLOR_SET",
        payload: color,
    }
}

export function popColorSet(){
    return {
        type: "POP_COLOR_SET",
        payload: null,
    }
}
export function addVisibleIndexes(item){
    return {
        type: "ADD_VISIBLE_INDEXES",
        payload: item,
    }
}

export function removeVisibleIndexes(item){
    return {
        type: "REMOVE_VISIBLE_INDEXES",
        payload: item,
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/filterGridAction.js
 **/